/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_End_TitleInputs */

const en_mk_tut_end_title = /** @type {(inputs: Mk_Tut_End_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready to try it yourself?`)
};

const id_mk_tut_end_title = /** @type {(inputs: Mk_Tut_End_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sudah siap mencobanya sendiri?`)
};

/**
* | output |
* | --- |
* | "Ready to try it yourself?" |
*
* @param {Mk_Tut_End_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_end_title = /** @type {((inputs?: Mk_Tut_End_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_End_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_end_title(inputs)
	return en_mk_tut_end_title(inputs)
});